import { useSyncExternalStore } from 'react';
import { useLocation } from 'react-router';
import { SISTEMA } from '../../copy/index.js';
import { actualizarAhora, hayVersionNueva, suscribirseALaVersionNueva } from '../../lib/pwa.js';
import { Boton } from './Boton.js';
import { ICONO, Info } from './iconos.js';

/**
 * El aviso de versión nueva (P-65).
 *
 * El service worker nuevo espera; esto le dice a la persona que hay una versión
 * nueva y le deja elegir cuándo. Tocar "Actualizar" recarga la página con la
 * versión nueva; no tocarlo no rompe nada, y la próxima vez que abra la app ya
 * la tiene.
 *
 * **No aparece durante el check-in.** Recargar a mitad de las preguntas sería
 * justo lo que la espera del service worker quiere evitar; al volver al inicio,
 * el aviso está.
 *
 * `role="status"`, como el banner offline: se anuncia sin interrumpir.
 */
export function AvisoDeActualizacion() {
  const hayNueva = useSyncExternalStore(suscribirseALaVersionNueva, hayVersionNueva, () => false);
  const { pathname } = useLocation();

  if (!hayNueva || pathname.startsWith('/checkin/')) return null;

  return (
    <div
      className="sticky top-0 z-[var(--z-sticky)] flex flex-wrap items-center gap-3 bg-brand-soft px-4 py-3"
      role="status"
    >
      <Info aria-hidden="true" className={`${ICONO.normal} shrink-0 text-heading`} />
      <p className="m-0 flex-1 text-md font-semi text-heading">{SISTEMA.actualizacion.mensaje}</p>
      <Boton escala="equipo" onClick={actualizarAhora}>
        {SISTEMA.actualizacion.actualizar}
      </Boton>
    </div>
  );
}
